export const SmartSendFilterCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
